import React, { Component } from 'react';
import '../../css/pages/auth.css';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import whiteLogo from '../../assets/svgs/logo-white.svg';
import { confirmEmail, login } from '../actions/auth';
import { fetchBusiness, fillUser } from '../actions/account';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: new URLSearchParams(props.location.search).get('token'),
      for: new URLSearchParams(props.location.search).get('for'),
      type: new URLSearchParams(props.location.search).get('type'),
    };
  }

  componentDidMount() {
    localStorage.removeItem('token');
    const { token, for: $for, type } = this.state;
    const { fetchBusiness, fillUser, history } = this.props;
    if (token && $for === 'verification') {
      toast.info('Verifying your link...');
      confirmEmail({ token, type })
        .then((response) => {
          if (response.status !== 'success') throw new Error(response?.message);
          toast.success(response?.message);
          localStorage.setItem('token', response?.data?.token);
          fillUser(response?.data);
          fetchBusiness();
          history.push('/onboarding');
        })
        .catch(() => toast.error('An error occured validating this link.'));
    }
  }

  handleOnChange = (e) => this.setState({
    [e.target.name]: e.target.value,
    [e.target.name + 'Error']: null,
  });

  handleLogin = (e) => {
    e.preventDefault();
    const { email, password, type } = this.state;
    const { fetchBusiness, fillUser, history } = this.props;
    this.setState({ processing: true }, async () => {
      try {
        const response = await login({ email, password, type });
        if (response.status !== 'success') throw new Error(response?.message);
        toast.success(response?.message);
        localStorage.setItem('token', response.data.token);
        fillUser(response?.data);
        fetchBusiness();
        if (response?.data?.organization?.status !== 'active') { history.push('/onboarding'); } else history.push('/dashboard');
      } catch (error) {
        this.setState({ processing: false }, () => toast.error(
          error.response?.data?.message
              || error.response?.statusText
              || error.message
              || 'Seems like something went wrong with your request. Please try again.',
        ));
      } finally {
        this.setState({ processing: false });
      }
    });
  };

  render() {
    const { processing } = this.state;
    return (
      <section className="auth">
        <header className="auth__header">
          <div className="auth__header--container">
            <img src={whiteLogo} alt="P2Vest Logo" />
          </div>
        </header>
        <main className="auth__main">
          <div className="auth__main--container">
            <div className="auth__text">
              <h3 className="auth__text--header">Welcome back!</h3>
              <p className="auth__text--subheader">
                Login to account with your details.
              </p>
            </div>
            <div className="auth__form">
              <form action="" onSubmit={this.handleLogin}>
                <div>
                  <div className="form-group">
                    <label htmlFor="businessEmail" className="form-label">
                      Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      onChange={this.handleOnChange}
                      required />
                    <div
                      className="form-text error-message"
                      style={{ display: 'none' }}>
                      <p>Email Address is required.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <div className="input-with-icon">
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        onChange={this.handleOnChange}
                        required />
                      <span className="input-icon" id="toggle-icon">
                        <svg width="20" height="20">
                          <use xlinkHref="../assets/icon-sprite.svg#eye-closed"></use>
                        </svg>
                        <svg width="20" height="20" hidden>
                          <use xlinkHref="../assets/icon-sprite.svg#eye-close-icon"></use>
                        </svg>
                      </span>
                    </div>
                    <div
                      className="form-text error-message"
                      style={{ display: 'none' }}>
                      <p>Password is required.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="type" className="form-label">
                      Select User Type
                    </label>

                    <select
                      name="type"
                      onChange={this.handleOnChange}
                      className="form-select"
                      aria-label="Default select example"
                      required>
                      <option selected>Select User Type</option>
                      <option value="business">Lending Business</option>
                      <option value="broker">Insurance Broker</option>
                    </select>

                    <div className="form-text error-message">
                      <p>A User Type is required.</p>
                    </div>
                  </div>
                </div>
                <div className="forgotPass mt-3">
                  <Link to="/forgotpassword">Forgot password?</Link>
                </div>
                <div className="buttonCTA">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    href="gettingstarted.html"
                    disabled={processing}>
                    {processing ? 'Processing...' : 'Login'}
                  </button>
                  <p>
                    New to P2Vest for Business?&nbsp;
                    <Link to="/register">Sign Up</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </main>
      </section>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  fetchBusiness,
  fillUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
